import React from 'react';
import { motion } from 'framer-motion';
import Saptagoniconpoints from '../../Assets/Home/Saptagoniconpoints.png';
import Footprint from '../../Assets/aboutsus/Map.gif';

const revenueData = [
  { year: '2019-20', value: 22 },
  { year: '2020-21', value: 40 },
  { year: '2021-22', value: 60 },
  { year: '2022-23', value: 89 },
  { year: '2023-24', value: 117 },
  { year: '2024-25', value: 148 },
];

const locations = [
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'J & K',
  'Karnataka',
  'Madhya Pradesh',
  'Maharashtra',
  'Punjab',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.05, duration: 0.5, ease: 'easeOut' },
  }),
};

const RevenueChart = () => {
  const chartW = 700;
  const chartH = 320;
  const baseline = 280;
  const top = 70;
  const maxVal = 148;
  const barW = 70;
  const gap = 40;
  const startX = 40;
  const scale = (baseline - top) / maxVal;

  const bars = revenueData.map((d, i) => {
    const x = startX + i * (barW + gap);
    const h = d.value * scale;
    const y = baseline - h;
    return { ...d, x, y, h, centerX: x + barW / 2 };
  });

  const arrowPts = bars.map((b) => ({ x: b.centerX, y: b.y - 18 }));
  const lastPt = arrowPts[arrowPts.length - 1];
  const tip = { x: lastPt.x + 40, y: lastPt.y - 40 };

  const linePath =
    `M ${arrowPts[0].x} ${arrowPts[0].y} ` +
    arrowPts
      .slice(1)
      .map((p, i) => {
        const prev = arrowPts[i];
        const midX = (prev.x + p.x) / 2;
        return `Q ${midX} ${prev.y}, ${p.x} ${p.y}`;
      })
      .join(' ') +
    ` Q ${(lastPt.x + tip.x) / 2} ${lastPt.y}, ${tip.x} ${tip.y}`;

  const angle = Math.atan2(tip.y - lastPt.y, tip.x - lastPt.x);
  const ah = 12;
  const arrowHead = `M ${tip.x} ${tip.y}
    L ${tip.x - ah * Math.cos(angle - 0.5)} ${tip.y - ah * Math.sin(angle - 0.5)}
    L ${tip.x - ah * Math.cos(angle + 0.5)} ${tip.y - ah * Math.sin(angle + 0.5)} Z`;

  return (
    <svg viewBox={`0 0 ${chartW} ${chartH}`} className="w-full h-auto">
      <defs>
        <linearGradient id="barGradient" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#61acca" />
          <stop offset="100%" stopColor="#8364c3" />
        </linearGradient>
      </defs>

      <line x1={20} y1={baseline} x2={chartW - 20} y2={baseline} stroke="#d8d8e6" strokeWidth="1" />

      {bars.map((b, i) => (
        <g key={b.year}>
          <motion.rect
            x={b.x}
            width={barW}
            rx="6"
            fill="url(#barGradient)"
            initial={{ y: baseline, height: 0 }}
            whileInView={{ y: b.y, height: b.h }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: 'easeOut' }}
          />
          <motion.text
            x={b.centerX}
            y={b.y - 28}
            textAnchor="middle"
            className="fill-[#213140] font-semibold"
            fontSize="18"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6 + i * 0.12 }}
          >
            {b.value}
          </motion.text>
          <text x={b.centerX} y={baseline + 22} textAnchor="middle" className="fill-stone-500" fontSize="12">
            {b.year}
          </text>
        </g>
      ))}

      <motion.path
        d={linePath}
        fill="none"
        stroke="#213140"
        strokeWidth="2.5"
        strokeLinecap="round"
        initial={{ pathLength: 0, opacity: 0 }}
        whileInView={{ pathLength: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, delay: 0.8, ease: 'easeInOut' }}
      />
      <motion.path
        d={arrowHead}
        fill="#213140"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 2 }}
      />

      <motion.text
  x={(arrowPts[2].x + arrowPts[3].x) / 2}
  y={(arrowPts[2].y + arrowPts[3].y) / 2 - 32}
  textAnchor="middle"
  className="fill-[#8364c3] font-bold"
  fontSize="20"
  transform={`rotate(-18 ${(arrowPts[2].x + arrowPts[3].x) / 2} ${(arrowPts[2].y + arrowPts[3].y) / 2 - 32})`}
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  transition={{ delay: 1.8 }}
>
  45% CAGR
</motion.text>

      <text x={chartW / 2} y="25" textAnchor="middle" className="fill-[#213140] font-bold" fontSize="18">
        Annual Revenue (In Cr) Vs Financial Year
      </text>
    </svg>
  );
};

const Revenue = () => {
  return (
    <div className="my-10 px-14 max-sm:px-4 sm:max-xl:px-4">
      <div className="relative max-sm:w-full w-full max-sm:px-0 max-sm:gap-4 max-sm:pt-0 flex flex-col justify-center items-center">
        <p className="purple font-semibold core-value">Revenue and Our Footprint</p>
        <p className="max-sm:w-full w-[50%] darkblue text-center md:text-4xl text-2xl font-semibold">
          Transforming Landscapes <span className="purple">Across India</span>
        </p>

        <div className="w-full flex max-sm:flex-col gap-8 md:gap-10 sm:max-xl:justify-center justify-center items-stretch md:mt-12">

          <motion.div
            className="w-full lg:w-1/2 bg-white rounded-2xl shadow-md p-6 md:p-8 flex flex-col"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUp}
          >
            <RevenueChart />
            <p className="text-sm md:text-base darkblue text-center mt-4">
              Achieving <b>45% CAGR</b> over the last 5 years, we lead infrastructure consultancy
              with topnotch tech, cutting-edge machinery, and a stellar in-house team.
            </p>
          </motion.div>

          <motion.div
            className="w-full lg:w-1/2 bg-white rounded-2xl shadow-md p-6 md:p-8 flex flex-col"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUp}
            custom={1}
          >
            <div className="flex items-center gap-2 mb-2">
              <img src={Saptagoniconpoints} alt="Saptagon" className="w-6" />
              <p className="md:text-lg font-semibold darkblue">Our Footprint</p>
              <span className="ml-auto text-xs font-semibold text-white bg-gradient-to-r from-[#61acca] to-[#8364c3] px-3 py-1 rounded-full">
                {locations.length} States
              </span>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-6 mt-4">
              <img src={Footprint} alt="Our Footprint across India" className="w-[70%] md:w-1/2" />

              <div className="w-full md:w-1/2 flex flex-wrap gap-2 content-start">
                {locations.map((location, index) => (
                  <motion.span
                    key={location}
                    custom={index}
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="text-xs md:text-sm darkblue bg-[#f2f0fa] border border-[#e3ddf5] rounded-full px-3 py-1"
                  >
                    {location}
                  </motion.span>
                ))}
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default Revenue;